import { ChipLabel } from '@atoms/chipLabel';

import { Search, X } from 'lucide-react';
import type React from 'react';
import { forwardRef } from 'react';

type Props = {
  searchVar: string;
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  selectedAction: string | null;
  resetSearch: React.MouseEventHandler<SVGSVGElement>;
};

export const SearchBar = forwardRef<HTMLInputElement, Props>(
  ({ searchVar, onSearch: handleSearch, selectedAction, resetSearch }, ref) => (
    <div className="flex h-11 items-center gap-1 p-3">
      <Search size={18} />
      {selectedAction && (
        <ChipLabel className="gap-3 rounded-sm">
          {selectedAction}
          <X className="cursor-pointer" onClick={resetSearch} size={14} />
        </ChipLabel>
      )}
      <input
        autoFocus
        className="w-full border-none bg-transparent outline-none"
        onChange={handleSearch}
        placeholder={`Search ${
          selectedAction
            ? `${selectedAction}'s variables`
            : 'all your variables...'
        }`}
        ref={ref}
        type="text"
        value={searchVar}
      />
    </div>
  )
);
